import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  civilStateLength: 0,
  civilState: []
}

export default function civilStateReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_CIVIL_STATE:
      return {...state, loading: action.payload}
    case actions.GET_CIVIL_STATE:
      return {...state, civilState: action.payload.civilState, civilStateLength: action.payload.civilStateLength}
    default:
      return state
  }
}